let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("l1FVz"), load("g6DP5"), load("aZinD"), load("75rSO")]).then(() => parcelRequire('1HlBH'));